import authMiddleware from './auth.middleware';

export default [authMiddleware];
